import type { SelectorOption } from '../Components/common';

export const MEDIA_TYPE_OPTIONS: SelectorOption[] = [
    { label: 'Raster', value: 'raster' },
    { label: 'Vector', value: 'vector' },
];

export const IMAGE_COUNT_OPTIONS: SelectorOption[] = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '4', value: '4' },
    { label: '8', value: '8' },
    { label: '16', value: '16' },
];
